import React, { useState } from "react";
import { FIELD_REGISTRY } from "./Config/fieldRegistry";
function ProductItemGrid({ variants = [], config, onEdit,
    onDelete }) {
    const [expandedItems, setExpandedItems] = useState({});

    // ✅ CONFIG SE SAB KUCH LE LO
    const columns = config?.table?.columns || [];
    const variantConfig = config?.variant_fields || { required: [], optional: [] };
    const allVariantFields = [...variantConfig.required, ...variantConfig.optional];

    // ✅ CHECK IF VARIANTS ENABLED
    const hasVariants = config?.components?.variants === true;

    // ✅ TOGGLE VARIANT EXPAND
    const toggleExpand = (index) => {
        setExpandedItems(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    // ✅ RENDER COLUMN VALUE - CONFIG BASED
    const renderValue = (item, column) => {
        if (column.render) {
            return column.render(item);
        }
        const value = item[column.key];
        if (value === undefined || value === null || value === '') {
            return <span className="text-muted">-</span>;
        }
        switch (column.type) {
            case 'price':
                return <span className="fw-bold">₹{Number(value).toLocaleString('en-IN')}</span>;
            case 'date':
                return new Date(value).toLocaleDateString('en-IN');
            case 'boolean':
                return value ? 'Yes' : 'No';
            case 'array':
                return Array.isArray(value) ? value.join(", ") : value;
            default:
                if (Array.isArray(value)) {
                    return value.length > 0 ? value.join(", ") : "-";
                }
                if (typeof value === 'boolean') {
                    return value ? 'Yes' : 'No';
                }
                return value;
        }
    };
    // ✅ RENDER VARIANT VALUE - CONFIG BASED

    const renderVariantValue = (variant, field) => {
        const value = variant[field];
        if (value === undefined || value === null || value === '') {
            return <span className="text-muted">-</span>;
        }

        const fieldConfig = FIELD_REGISTRY[field];
        const type = fieldConfig?.type;
        if (type === 'price' || field === 'price' || field === 'selling_price' || field === 'mrp' || field === 'purchase_price') {
            return <span className="fw-bold">₹{Number(value).toLocaleString('en-IN')}</span>;
        }

        if (type === 'multi_select' || field === 'color_ids' || field === 'size_ids' || field === 'material_ids' || field === 'pattern_ids') {
            if (Array.isArray(value)) {
                return value.length > 0 ? value.join(', ') : '-';
            }
            return value || '-';
        }

        if (type === 'select') {
            return value || '-';
        }
        if (type === 'number' || field === 'stock') {
            return <span className="badge bg-success">{value}</span>;
        }
        if (type === 'boolean' || typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        }

        if (field === 'warranty') {
            return <span className="badge bg-info">{value}</span>;
        }
        if (field === 'imei') {
            return <code>{value}</code>;
        }

        return value;
    };
    const getFieldLabel = (fieldName) => {
        const fieldConfig = FIELD_REGISTRY[fieldName];
        // Agar registry mein label hai toh wo use karo, warna capitalise kar do
        return fieldConfig?.label || fieldName.replace('_', ' ').toUpperCase();
    };

    // ✅ GET VARIANT DISPLAY FIELDS
    const getVariantDisplayFields = () => {
        if (variantConfig.displayFields) {
            return variantConfig.displayFields;
        }
        return allVariantFields;
    };

    const variantDisplayFields = getVariantDisplayFields();

    return (
        <div className="card mt-4">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                    <i className="fa fa-list me-2"></i>
                    Added Product Items
                    {/* <span className="badge bg-primary ms-2">{items.length}</span> */}
                </h5>
            </div>

            <div className="st-wrapper-card text-center">
                <div className="st-table-responsive">
                    <table className="table st-custom-table align-middle mb-0">
                        <thead>
                            <tr>
                                <th>#</th>
                                {variantDisplayFields.map((field) => (
                                    <th key={field}>
                                        {getFieldLabel(field)}
                                    </th>
                                ))}


                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {variants.map((variant, index) => (
                                <tr key={index}>

                                    <td>{index + 1}</td>

                                    {variantDisplayFields.map(field => (
                                        <td key={field}>
                                            {renderVariantValue(variant, field)}
                                        </td>
                                    ))}

                                    <td>
                                        <button
                                            className="btn btn-warning btn-sm"
                                            onClick={() => onEdit(index)}
                                        >
                                            Edit
                                        </button>

                                        <button
                                            className="btn btn-danger btn-sm ms-2"
                                            onClick={() => onDelete(index)}
                                        >
                                            Delete
                                        </button>
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default ProductItemGrid;